import type { Shortcut } from './KeyLegend.js'

/** On every game screen, so leaving is never something you have to work out. */
export const LEAVE_SHORTCUT: Shortcut = { keys: ['Esc'], does: 'Back to the games' }
